import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';
import AtlasV2MarketShareGrid from 'src/components/AtlasV2Components/AtlasV2SalesPageComponents/AtlasV2MarketShareGrid';
import AtlasV2Sales1P3PSplineChart from 'src/components/AtlasV2Components/AtlasV2SalesPageComponents/AtlasV2Sales1P3PSplineChart';
import AtlasV2Sales1PTotalSalesSplineChart from 'src/components/AtlasV2Components/AtlasV2SalesPageComponents/AtlasV2Sales1PTotalSalesSplineChart';
import AtlasV2SalesDoubleDropdownTopEntityChart from 'src/components/AtlasV2Components/AtlasV2SalesPageComponents/AtlasV2SalesDoubleDropdownTopEntityChart';
import AtlasV2SalesMarketShareOfMultipleSelectSplineChart from 'src/components/AtlasV2Components/AtlasV2SalesPageComponents/AtlasV2SalesMarketShareOfMultipleSelectSplineChart';
import AtlasV2SalesProductGrid from 'src/components/AtlasV2Components/AtlasV2SalesPageComponents/AtlasV2SalesProductGrid';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import {
  useBrandEntity,
  useBusinessUnitEntity,
  useCategoryEntity,
  useMainEntityType,
  useProductEntity,
  useSegmentEntity,
  useSubcategoryEntity
} from 'src/utils/Hooks/reduxSelectors';
import { shouldShowOnePRetailSales } from 'src/utils/app';
import AtlasV2SalesMarketShareSplineChart from 'src/components/AtlasV2Components/AtlasV2SalesPageComponents/AtlasV2SalesMarketShareSplineChart';
import AtlasV2SalesProductCountSplineChart from 'src/components/AtlasV2Components/AtlasV2SalesPageComponents/AtlasV2SalesProductCountSplineChart';
import AtlasV2SalesDropdownTopEntityChart from 'src/components/AtlasV2Components/AtlasV2SalesPageComponents/AtlasV2SalesDropdownTopEntityChart';
import AtlasV2DoubleDropdownCategoryMarketShareChart from 'src/components/AtlasV2Components/AtlasV2SalesPageComponents/AtlasV2DoubleDropdownCategoryMarketShareChart';
import AtlasV2SalesMarketShareProductSplineChart from 'src/components/AtlasV2Components/AtlasV2SalesPageComponents/AtlasV2SalesMarketShareProductSplineChart';
import AtlasV2MarketShareDropdownTopEntityChart from 'src/components/AtlasV2Components/AtlasV2SalesPageComponents/AtlasV2MarketShareDropdownTopEntityChart';
import { useAppSelector } from 'src/utils/Hooks';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';

export const ONE_P_THRESHOLD = 25;

/**
 * Atlas V2 Summary Page layout - Tab name: sales subtab name: retailSales
 */
export const AtlasV2SalesSummaryPageLayout = () => {
  const mainEntityType = useMainEntityType();
  const { isProductEntity } = useProductEntity();
  const { isCategoryEntity } = useCategoryEntity();
  const { isSubcategoryEntity } = useSubcategoryEntity();
  const { isBrandEntity } = useBrandEntity();
  const { isSegmentEntity } = useSegmentEntity();
  const { isBusinessUnitEntity } = useBusinessUnitEntity();
  const skuCount = useAppSelector((state) => state.entityService.mainEntity.skuCount);
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  // for segment, if sku count is less than or equal to 25, hide the one P, three P spline chart
  return shouldShowOnePRetailSales() && !(isSegmentEntity && skuCount <= ONE_P_THRESHOLD) ? (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        {/* One P, Three P spline chart that will have split.io implemented in.  */}
        {!isProductEntity ? (
          <AtlasV2Sales1P3PSplineChart />
        ) : (
          <AtlasV2ComparableSplineChart indexName="sales" fieldName="retailSales" />
        )}
        {/* Market Share of Retail Sales (One P, Three P) - split,io in */}
        {(mainEntityType === 'company' || isBrandEntity) && <AtlasV2SalesMarketShareOfMultipleSelectSplineChart />}
        {/* oneP Retail sales vs total */}

        {/* Product Count */}
        {!isProductEntity && <AtlasV2SalesProductCountSplineChart />}

        {mainEntityType === 'company' && <AtlasV2Sales1PTotalSalesSplineChart />}

        {/* Double dropdown top entity retail sales, one P, three P  */}
        {isCategoryEntity || isSubcategoryEntity || isSegmentEntity || isBusinessUnitEntity ? (
          <AtlasV2DoubleDropdownCategoryMarketShareChart />
        ) : !isProductEntity && !isBrandEntity ? (
          <AtlasV2SalesDoubleDropdownTopEntityChart />
        ) : null}

        {/* Market Share Table */}
        {(isCategoryEntity || isSubcategoryEntity || isSegmentEntity || isBusinessUnitEntity) && (
          <AtlasV2MarketShareGrid />
        )}

        {(isCategoryEntity || isSubcategoryEntity || isBrandEntity || isSegmentEntity || isBusinessUnitEntity) && (
          //  Double Dropdown Retail Sales, 1P, 3P by Brand Manufacturer
          <AtlasV2SalesDoubleDropdownTopEntityChart />
        )}

        {(isCategoryEntity || isSubcategoryEntity || isBrandEntity || isSegmentEntity || isBusinessUnitEntity) && (
          //  Double Dropdown Retail Sales, 1P, 3P by Brand Manufacturer
          <AtlasV2Sales1PTotalSalesSplineChart />
        )}

        {isProductEntity && <AtlasV2SalesMarketShareProductSplineChart />}

        {/* Product Grid */}
        <AtlasV2SalesProductGrid />
      </Flex>
    </BasePageContainer>
  ) : (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        {/* Retail Sales Chart  */}
        <AtlasV2ComparableSplineChart indexName="sales" fieldName="retailSales" />
        {/* Market Share of Retail Sales  */}
        {(mainEntityType === 'company' || isBrandEntity || isProductEntity) && <AtlasV2SalesMarketShareSplineChart />}

        {/* Product Count */}
        {!isProductEntity && <AtlasV2SalesProductCountSplineChart />}

        {/* dropdown top entity retail sales  */}
        {!isCategoryEntity &&
          !isSubcategoryEntity &&
          !isBrandEntity &&
          !isProductEntity &&
          !isSegmentEntity &&
          !isBusinessUnitEntity && <AtlasV2SalesDropdownTopEntityChart />}

        {(isCategoryEntity || isSubcategoryEntity || isSegmentEntity || isBusinessUnitEntity) && (
          <AtlasV2MarketShareDropdownTopEntityChart />
        )}

        {/* MarketShare Grid */}
        {(isCategoryEntity ||
          isSubcategoryEntity ||
          isBusinessUnitEntity ||
          isSegmentEntity ||
          mainEntityType === 'businessunit') && <AtlasV2MarketShareGrid />}

        {(isCategoryEntity || isSubcategoryEntity || isSegmentEntity || isBrandEntity || isBusinessUnitEntity) && (
          <AtlasV2SalesDropdownTopEntityChart />
        )}
        {/* Product Grid */}
        <AtlasV2SalesProductGrid />
      </Flex>
    </BasePageContainer>
  );
};
